import React, { FC } from 'react';

import List from 'components/List';
import Card from 'components/Card';
import { CardV2, useCardV2Enabled } from 'components/CardV2';
import { mapLayout } from 'components/CardV2/helpers/mapLayout';
import useTheme from 'helpers/useTheme';

import { CardTypeOptions, DiscoverItemSchema } from 'constants/graphqlTypes';
import { RefIdProvider } from 'helpers/useContextRefID';
import { CardProvider } from 'helpers/useCardProvider';
import { StyledListItem } from './styled';
import { hasPaddings, REF_PLACEHOLDER } from './helpers';

const { Collection, UserGroup, SuggestedUsers } = CardTypeOptions;

const Item: FC<{ item: DiscoverItemSchema; dataTestId?: string }> = ({ item, dataTestId }) => {
  const { card, layout, referrerId, highlight, cardHeader } = item;
  const { type } = card;

  const isDark = useTheme();
  const useNewCard = useCardV2Enabled(card);
  const layoutType = mapLayout(layout);

  const isList = type === Collection || type === UserGroup || type === SuggestedUsers;

  // Padding: legacy cards check hasPaddings(layout); CardV2 cards check layoutType
  const shouldHavePaddings = useNewCard
    ? layoutType !== 'fullBleed' && layoutType !== 'immersive'
    : !!layout && hasPaddings(layout) && !isList;

  return (
    <RefIdProvider value={{ referrerId: referrerId ?? REF_PLACEHOLDER }}>
      <CardProvider value={{ cardHeader }}>
        <StyledListItem key={card.id} hasPaddings={shouldHavePaddings}>
          {isList && layout && <List layout={layout} list={card} />}
          {type === CardTypeOptions.Card &&
            (useNewCard ? (
              <CardV2 card={card} variant="discovery" layoutType={layoutType} dataTestId={dataTestId} />
            ) : (
              <Card dataTestId={dataTestId} layout={layout} isDark={isDark} card={card} highlight={highlight} />
            ))}
        </StyledListItem>
      </CardProvider>
    </RefIdProvider>
  );
};

export default Item;
